export default __webpack_public_path__ + "static/media/CNo.78-1.9e9489b7.jpg";